export enum MANAGE_GROUP_STEPS {
    AddFiles = "AddFiles",
    Initial = "Initial"
}

export enum PAYLOAD_FILE_TYPES {
    ConfigurationFileId = "configuration_file_id",
    FirmwareFileId = "firmware_file_id",
    FtConfigurationFileId = "ft_configuration_file_id",
    FtFirmwareFileId = "ft_firmware_file_id",
    FtOneWireAuthorizationListFileId = "ft_one_wire_auth_list_file_id",
    FtBluetoothAuthorizationListFileId = "ft_bluetooth_auth_list_file_id"
}
